export default `
§ uiKit.console.button: Copier
§ uiKit.console.notification: Texte copié
§ uiKit.dataLoader.page: Page
§ uiKit.dataLoader.size: Affiché par
§ uiKit.dataLoader.from: de
§ uiKit.dataLoader.all: Afficher tout
§ uiKit.hoursChart.work: temps de travail standard (Les jours ouvrables de 07h00 à 20h00)
§ uiKit.hoursChart.weekend: Jours ou heures avant/après les jours ouvrables
§ uiKit.hoursChart.days: La somme des commits au cours de tout le temps un certain jour et une certaine heure
§ uiKit.page.remove: Supprimer
§ uiKit.nothingFound.common.title: Il n’y a pas ou pas assez de données pour afficher.
§ uiKit.nothingFound.common.description: Le système traite plus de données si les commits sont signés au format [Git commit message convention|https://www.conventionalcommits.org/en/v1.0.0/]. Modèle:
§ uiKit.nothingFound.common.console: Numéro_adresse type(modules): explication
§ uiKit.nothingFound.common.example: Par exemple:
§ uiKit.nothingFound.staff.title: Il n & apos; y a pas de données sur ce fonctionnaire.
§ uiKit.nothingFound.staff.description1:
Il a apporté des modifications pas tous les jours ouvrable. Par conséquent, il a reçu le statut  «Assistant».
La statistique du collaborateur avec ce statut peut ne pas être prise en compte. Son impact est insignifiant.
§ uiKit.nothingFound.staff.description2:
Le système ne calcule pas pour lui plusieurs indicateurs.
Si c’est une erreur et que la statistique pour ce collaborateur doit être prise en compte, accédez à la section “Paramètres” et modifiez son type.
§ common.title: Git statistique
§ common.filters: Filtres
§ common.notifications.save: Modifications enregistrées
§ common.notifications.setting: Paramètres enregistrés
`;
